export const SAVED_MARKET_INFO = <>
    <p>Find your saved markets in this section.</p>
    <p>You can add items to the "My Saved Markets" section by clicking "Save" in the right-hand panel after making your
        market selections.</p>
    <p>This is great for quickly accessing your most frequently used markets.</p>
</>;
